import React from "react";
var __jsx = React.createElement;
import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { loadableReady } from "@loadable/component";
import { createRoot } from "react-dom/client";
import App from "./App";
import extractedRoutes from "./routes/routes";
import "./styles/fontStyle.css";
import Loader from "@componentsShared/Loader/Loader";
import "./Polyfills";
import { external_first_interaction } from "@hooks/useIsFirstInteraction";
import { AuthProvider } from "@/_MiniApps/auth/AuthContext";
import { CarCompareProvider } from "./_MiniApps/CarCompare/CarCompare";
import { RecentlyViewedProvider } from "./_MiniApps/RecentlyViewedContext/RecentlyViewedContext";
import { AribFinanceContextProvider } from "@/common/Contexts/AribFinanceContext";
import CurrencyFontProvider from "@/_MiniApps/CurrencyFont/CurrencyFontProvider";
import { ConsentContextProvider } from "@/common/Contexts/Consent/ConsentContext";
var routes = extractedRoutes();
var AppContainer = function AppContainer() {
  useEffect(function () {
    external_first_interaction();
  }, []);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Loader, null)
  }, /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(AuthProvider, null, /*#__PURE__*/React.createElement(ConsentContextProvider, null, /*#__PURE__*/React.createElement(CarCompareProvider, null, /*#__PURE__*/React.createElement(RecentlyViewedProvider, null, /*#__PURE__*/React.createElement(AribFinanceContextProvider, null, /*#__PURE__*/React.createElement(CurrencyFontProvider, null, /*#__PURE__*/React.createElement(App, {
    routes: routes
  })))))))));
};
loadableReady(function () {
  var root = createRoot(document.getElementById('root'));
  root.render(/*#__PURE__*/React.createElement(AppContainer, null));
});
if (module.hot) {
  module.hot.accept();
}